// ═══ 4면도 도식 — 기존 웹 4면도(신고 241) 컴포넌트 재사용 (신고 371 §9 결정 5) ═══
// components/EvalCarDiagram.js 의 PanelSvg(지오메트리·PNG·SVG 채색·기호)를 그대로 쓰고
// 면 캡션만 ARB 키로 갈아끼운다(그 파일의 라벨은 한국어 하드코딩). 색 상수도 그 파일에서 온다
// (v2/ 아래 hex 리터럴 0 가드).
// props: { views, resolveColor, resolveSymbol, t }  views = ['left','top','right'] 등 렌더 순서.
// 데이터 유무와 무관하게 넘긴 면을 전부 그린다 — 리포트와 같은 규칙(어느 면을 봤는지 알린다).
import React from 'react';
import { PanelSvg } from '../../../../../components/EvalCarDiagram';
import { viewLabel } from './domain';

var row = { display: 'flex', gap: 6, flexWrap: 'wrap', maxWidth: 480, margin: '0 auto' };

// 4면(사고)은 2×2, 3면(도막)은 한 줄 — 패널 폭이 116px 로 줄어 기호가 작아지던 것 (신고 384)
function CarDiagram(props) {
  var t = props.t;
  var cell = { flex: props.views.length === 4 ? '1 1 calc(50% - 6px)' : 1, minWidth: 0 };
  return (<div className="ss-car-diagram" style={row} dir="ltr">
    {props.views.map(function (key) {
      return (<div key={key} style={cell}><PanelSvg panelKey={key} caption={viewLabel(t, key)}
        resolveColor={props.resolveColor} resolveSymbol={props.resolveSymbol} /></div>);
    })}
  </div>);
}

export default CarDiagram;
